import { render, staticRenderFns } from "./InvalidHCID.vue?vue&type=template&id=1973c2ae"
import script from "./InvalidHCID.vue?vue&type=script&lang=js"
export * from "./InvalidHCID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports